import { call, put, takeLatest } from 'redux-saga/effects';
import { replace } from 'connected-react-router';

import { psmAuditDigital, notification } from '../../actionTypes';
import dataProvider from '../../store/dataProvider';
import { formatPath } from '../../utils/textFormaters';
import routes from '../../ui/routes/path';
import { getNotificationErrorMessage } from './helpers';

function* create({ payload: { companyId, data } }) {
  try {
    const { data: response } = yield call(dataProvider.createOne, 'audit', data);
    const audit = (response && response.data) || response || null;
    yield put({ type: psmAuditDigital.create.end, payload: audit });
    yield put({ type: notification.add, payload: { success: 'Audit saved successfully' } });
    yield put({ type: psmAuditDigital.list.start, payload: { companyId } });
    if (data.isDraft && audit?.id && companyId) {
      yield put(replace(formatPath(routes.private.company.psmAuditEdit, { id: companyId, auditId: audit.id })));
    } else if (!data.isDraft) {
      yield put({ type: psmAuditDigital.pendingCompanyRedirectSet, payload: { companyId } });
    }
  } catch (e) {
    yield put({ type: psmAuditDigital.create.error });
    yield put({ type: notification.add, payload: { error: getNotificationErrorMessage(e, 'Failed to save audit') } });
  }
}

export default function* createSaga() {
  yield takeLatest(psmAuditDigital.create.start, create);
}
